import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';
import { DocumentNotFound } from './components';

export const routes: RouteObject[] = [
  {
    path: paths.documents.root,
    element: <Outlet />,
    children: [
      {
        path: paths.documents.root,
        element: loadable(() => import('./pages/DocumentsRepository')),
      },
      {
        path: paths.documents.preview,
        element: loadable(() => import('./pages/DocumentPreviewPage')),
      },
      {
        path: paths.documents.document,
        element: loadable(() => import('./pages/DocumentViewerPage')),
      },
      {
        path: paths.documents.any,
        element: <DocumentNotFound />,
      },
    ],
  },
];
